export default function convertToAbsoluteAmountValue(amount) {
  return Math.abs(amount)
}